import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TVPage = () => {
  const [fiyatlar, setFiyatlar] = useState([]);
  const [params, setParams] = useState({
    oda_adi: "Cizre Kuyumcular Odası",
    baskan_adi: "Başkan Adı"
  });
  const [currentTime, setCurrentTime] = useState(new Date());

  const fetchData = useCallback(async () => {
    try {
      const [fiyatRes, paramRes] = await Promise.all([
        axios.get(`${API}/fiyatlar`),
        axios.get(`${API}/parametreler-public`)
      ]);
      setFiyatlar(fiyatRes.data);
      setParams(paramRes.data);
    } catch (error) {
      console.error("Error:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 61000);
    return () => clearInterval(interval);
  }, [fetchData]);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getArrow = (durum) => {
    if (durum === "up") return "▲";
    if (durum === "down") return "▼";
    return "−";
  };

  const getColor = (durum) => {
    if (durum === "up") return "#22c55e";
    if (durum === "down") return "#ef4444";
    return "#94a3b8";
  };

  // Simple inline styles for maximum compatibility
  const styles = {
    container: {
      width: "100%",
      height: "100vh",
      margin: 0,
      padding: 0,
      backgroundColor: "#f8fafc",
      fontFamily: "Arial, Helvetica, sans-serif",
      overflow: "hidden"
    },
    header: {
      backgroundColor: "#1e293b",
      padding: "12px 20px",
      color: "white"
    },
    headerContent: {
      display: "table",
      width: "100%"
    },
    headerLeft: {
      display: "table-cell",
      verticalAlign: "middle"
    },
    headerRight: {
      display: "table-cell",
      verticalAlign: "middle",
      textAlign: "right"
    },
    title: {
      fontSize: "22px",
      fontWeight: "bold",
      margin: 0,
      color: "white"
    },
    subtitle: {
      fontSize: "13px",
      color: "#fcd34d",
      margin: "4px 0 0 0"
    },
    time: {
      fontSize: "14px",
      color: "#94a3b8"
    },
    live: {
      display: "inline-block",
      backgroundColor: "#22c55e",
      color: "white",
      padding: "4px 10px",
      borderRadius: "12px",
      fontSize: "11px",
      fontWeight: "bold",
      marginRight: "12px"
    },
    tableContainer: {
      padding: "16px",
      height: "calc(100vh - 80px)",
      overflow: "hidden"
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "white",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    },
    th: {
      backgroundColor: "#f1f5f9",
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#475569",
      borderBottom: "2px solid #e2e8f0"
    },
    thRight: {
      backgroundColor: "#f1f5f9",
      padding: "14px 16px",
      textAlign: "right",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#475569",
      borderBottom: "2px solid #e2e8f0"
    },
    thCenter: {
      backgroundColor: "#f1f5f9",
      padding: "14px 16px",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#475569",
      borderBottom: "2px solid #e2e8f0"
    },
    td: {
      padding: "12px 16px",
      fontSize: "15px",
      color: "#1e293b",
      borderBottom: "1px solid #f1f5f9"
    },
    tdRight: {
      padding: "12px 16px",
      fontSize: "15px",
      fontWeight: "bold",
      color: "#1e293b",
      textAlign: "right",
      borderBottom: "1px solid #f1f5f9",
      fontFamily: "monospace"
    },
    tdCenter: {
      padding: "12px 16px",
      fontSize: "18px",
      textAlign: "center",
      borderBottom: "1px solid #f1f5f9"
    },
    footer: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#1e293b",
      color: "#94a3b8",
      textAlign: "center",
      padding: "8px",
      fontSize: "11px"
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.headerLeft}>
            <h1 style={styles.title}>{params.oda_adi.toUpperCase()}</h1>
            <p style={styles.subtitle}>{params.baskan_adi} - Tavsiye Edilen Fiyat Listesi</p>
          </div>
          <div style={styles.headerRight}>
            <span style={styles.live}>● CANLI</span>
            <span style={styles.time}>{currentTime.toLocaleTimeString('tr-TR')}</span>
          </div>
        </div>
      </div>

      {/* Table */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Ürün</th>
              <th style={styles.thRight}>Alış</th>
              <th style={styles.thRight}>Satış</th>
              <th style={styles.thCenter}>Durum</th>
            </tr>
          </thead>
          <tbody>
            {fiyatlar.map((fiyat, index) => (
              <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "white" : "#f8fafc" }}>
                <td style={styles.td}>{fiyat.urun_adi}</td>
                <td style={styles.tdRight}>{fiyat.alis}</td>
                <td style={styles.tdRight}>{fiyat.satis}</td>
                <td style={{ ...styles.tdCenter, color: getColor(fiyat.durum) }}>
                  {getArrow(fiyat.durum)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        © 2025 AppSaRRaF - Keyf Teknoloji - 0507 744 90 65
      </div>
    </div>
  );
};

export default TVPage;
